import { extendMoment } from 'moment-range';
import moment from 'moment-timezone';

import FLAG from 'config/flag.singleton';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromAnyDateToZulu, fromMomentToIso } from 'utils/converters/time/from.util';
import { formatHourAndMinute } from 'utils/date/format.util';
import logger from 'utils/logger.util';
import parseBusinessHour from 'utils/parsers/parseBusinessHour.util';

const L = logger('calculateFilteredRangeOfHours');

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);
const STEP = 15;

const m = extendMoment(moment);

const fromIsoToObject = (iso) => ({ iso, value: fromAnyDateToZulu(iso), description: formatHourAndMinute(iso) });

const generateSequence = (options) => {
  const { bgn, end, step } = options ?? {};

  return [...m.range(bgn, end).by('minutes', { step })].map(fromMomentToIso);
};

const calculateFilteredRangeOfHours = (options) => {
  const { hours, dayOfWeek, expanded } = options ?? {};

  if (dayOfWeek < 0 || dayOfWeek >= 7) L.warn('()', 'Invalid dayOfWeek:', dayOfWeek);

  const openTime = expanded ? '07:00:00' : hours?.[dayOfWeek]?.open_time;
  const closeTime = expanded ? '22:00:00' : hours?.[dayOfWeek]?.close_time;

  const bgn = parseBusinessHour(openTime).iso;
  const end = parseBusinessHour(closeTime).iso;

  if (USE_SPAM_LOG) L.debug('()', expanded, openTime, closeTime, hours?.[dayOfWeek], bgn, end);

  return generateSequence({ bgn, end, step: STEP }).map(fromIsoToObject);
};

export default calculateFilteredRangeOfHours;
